var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#6B696A",
    strokeWidth: 1.5,
    d: "M23.375 17.469c0-1.146-.401-2.12-1.203-2.922s-1.776-1.203-2.922-1.203c-.831 0-1.59.229-2.277.687-.602-1.031-1.433-1.861-2.493-2.492-1.06-.63-2.22-.945-3.48-.945-1.891 0-3.509.673-4.855 2.02-1.347 1.346-2.02 2.964-2.02 4.855v.344c-1.203.429-2.191 1.175-2.965 2.234C.387 21.107 0 22.31 0 23.656c0 1.719.602 3.18 1.805 4.383 1.203 1.203 2.664 1.805 4.383 1.805H22c1.518 0 2.814-.537 3.889-1.611 1.074-1.075 1.611-2.37 1.611-3.89 0-.858-.193-1.675-.58-2.448-.387-.774-.91-1.418-1.568-1.934-.66-.515-1.404-.845-2.235-.988.172-.487.258-.988.258-1.504z",
    transform: "translate(-65 -52) translate(65.75 52.75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M22.15 7.5c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8",
    transform: "translate(-65 -52) translate(65.75 52.75)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeWidth: 1.5,
    d: "M22.15 7.5c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8z",
    transform: "translate(-65 -52) translate(65.75 52.75)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#368FEF",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 12,
    fontWeight: "bold",
    transform: "translate(-65 -52) translate(65.75 52.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.495,
    y: 19.438
  }, "!")), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M28.65 7L31.65 4M33.65 26L30.65 23M33.65 15L37.65 15M21.65 4L21.65 0M15.65 7L12.65 4",
    transform: "translate(-65 -52) translate(65.75 52.75)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.5c47176b6083a8d8d9cbe22cc19a3cd0.svg";
export { ForwardRef as ReactComponent };